import { services } from '../data/services';

const Item = ({ text }) => (
  <span className="mx-6 inline-flex items-center gap-6 sm:mx-10 sm:gap-10">
    <span className="whitespace-nowrap font-display text-lg italic text-forest sm:text-2xl">
      {text}
    </span>
    <span className="text-pine" aria-hidden="true">
      ✦
    </span>
  </span>
);

export const Marquee = () => {
  const items = services.map((s) => s.shortTitle);
  return (
    <div
      data-testid="services-marquee"
      className="relative overflow-hidden border-y border-forest/15 bg-white py-5 sm:py-6"
      aria-label="TheBigHub core services"
    >
      <div className="flex w-max animate-marquee will-change-transform">
        <div className="flex">
          {items.map((t, i) => (
            <Item key={`a-${i}`} text={t} />
          ))}
        </div>
        <div className="flex" aria-hidden="true">
          {items.map((t, i) => (
            <Item key={`b-${i}`} text={t} />
          ))}
        </div>
      </div>
    </div>
  );
};
